import React from 'react';
import { Card } from '../ui/card';
import { Banknote, Clock, User, Phone } from 'lucide-react';
import { Button } from '../ui/button';

const RideInfoCard = ({ ride }) => {
  const callCustomer = () => {
    if (ride.userPhone) {
      window.location.href = `tel:${ride.userPhone}`;
    }
  };

  return (
    <Card className="p-6">
      <h2 className="text-lg font-bold mb-4">Ride Details</h2>
      
      <div className="space-y-4">
        {/* Customer Info - Prominent Display */}
        <div className="bg-gradient-to-r from-pink-50 to-purple-50 rounded-lg p-4 border border-pink-200">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
              {ride.userName?.charAt(0) || 'R'}
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <User className="h-4 w-4 text-gray-500" />
                <span className="text-sm text-gray-600">Customer</span>
              </div>
              <p className="font-semibold text-gray-900 text-lg">{ride.userName || 'Customer'}</p>
              {ride.userPhone && (
                <div className="flex items-center gap-2 mt-1">
                  <Phone className="h-3 w-3 text-gray-500" />
                  <a href={`tel:${ride.userPhone}`} className="text-pink-600 hover:underline text-sm">
                    {ride.userPhone}
                  </a>
                </div>
              )}
            </div>
            {ride.userPhone && (
              <Button
                onClick={callCustomer}
                size="sm"
                className="bg-green-600 hover:bg-green-700"
              >
                <Phone className="h-4 w-4 mr-1" />
                Call
              </Button>
            )}
          </div>
        </div>

        {/* Pickup */}
        <div className="flex items-start gap-3">
          <div className="w-3 h-3 bg-green-500 rounded-full mt-2"></div>
          <div className="flex-1">
            <p className="text-sm text-gray-600">Pickup Location</p>
            <p className="font-medium text-gray-900">{ride.pickup}</p>
          </div>
        </div>

        {/* Dropoff */}
        <div className="flex items-start gap-3">
          <div className="w-3 h-3 bg-red-500 rounded-full mt-2"></div>
          <div className="flex-1">
            <p className="text-sm text-gray-600">Dropoff Location</p>
            <p className="font-medium text-gray-900">{ride.dropoff}</p>
          </div>
        </div>

        <div className="border-t pt-4 grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-600 flex items-center gap-1">
              <Banknote className="h-4 w-4" />
              Fare
            </p>
            <p className="text-xl font-bold text-green-600">K{ride.price?.toFixed(2)}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600 flex items-center gap-1">
              <Clock className="h-4 w-4" />
              Distance
            </p>
            <p className="text-xl font-bold">{ride.distance?.toFixed(1)} km</p>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default RideInfoCard;
